/**
 * @license Copyright (c) 2003-2014, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or http://ckeditor.com/license
 */

CKEDITOR.editorConfig = function( config ) {
	// Define changes to default configuration here. For example:
	// config.language = 'fr';
    // config.uiColor = '#AADC6E';

  config.filebrowserBrowseUrl = 'assets/ckfinder/ckfinder.html';
  config.filebrowserImageBrowseUrl = 'assets/ckfinder/ckfinder.html?Type=Images';
  config.filebrowserFlashBrowseUrl = 'assets/ckfinder/ckfinder.html?Type=Flash';
  config.filebrowserUploadUrl = 'assets/ckfinder/core/connector/aspx/connector.aspx?command=QuickUpload&type=Files';
  config.filebrowserImageUploadUrl = 'assets/ckfinder/core/connector/aspx/connector.aspx?command=QuickUpload&type=Images';
  config.filebrowserFlashUploadUrl = 'assets/ckfinder/core/connector/aspx/connector.aspx?command=QuickUpload&type=Flash';
  config.fileTools_requestHeaders = {
    Authorization: 'Bearer ' + localStorage.getItem('access_token')
}
  //config.filebrowserImageBrowseUrl = 'assets/ckfinder/ckfinder.html?Type=Images';
  //config.filebrowserFlashBrowseUrl = 'assets/ckfinder/ckfinder.html?Type=Flash';
  //config.filebrowserUploadUrl = 'assets/ckfinder/core/connector/aspx/connector.aspx?command=QuickUpload&type=Files';
  //config.filebrowserImageUploadUrl = 'assets/ckfinder/core/connector/aspx/connector.aspx?command=QuickUpload&type=Images';
  //config.filebrowserFlashUploadUrl = 'assets/ckfinder/core/connector/aspx/connector.aspx?command=QuickUpload&type=Flash';


};
